import Lottie from "lottie-react"
import loaderAnimation from "../../src/assets/lottie/coming_soon.json"
import ProfileSidebar from "../components/CandidateProfileSidebar"

const ResumeAnalysisPage = () => {
  return (
    <div className="bg-gray-50 font-satoshi min-h-screen">
      <div className="flex flex-col lg:flex-row">
        {/* Left sidebar - hidden on mobile, fixed width on desktop */}
        <div className="lg:w-60 border-r border-gray-200 overflow-y-auto lg:fixed lg:left-0 lg:top-0 lg:h-screen">
          <ProfileSidebar activeTab="inbox" setActiveTab={() => {}} />
        </div>

        {/* Main content */}
        <div className="flex-1 lg:ml-60 overflow-y-auto bg-white">
          <div className="w-full">
            <div className="min-h-screen">
              <div className="w-full px-4 sm:px-6 lg:px-10 py-4 lg:py-0">
                <div className="bg-white relative">
                  <div className="min-h-screen flex items-center justify-center">
                    <div className="text-center w-full max-w-md mx-auto px-4">
                      <Lottie
                        animationData={loaderAnimation}
                        loop={true}
                        autoplay={true}
                        className="w-full h-auto max-w-[300px] sm:max-w-[400px] mx-auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResumeAnalysisPage
